// 后台互动小说三个命名空间的日文文案；key 结构与 en 完全一致（test/i18n.test.js 校验）。
export const novelJa = {
  novelPacks: {
    title: 'インタラクティブ小説作品',
    filters: { status: 'ステータス', allStatuses: 'すべてのステータス', search: 'キーワード', searchPlaceholder: 'タイトル、スラッグ、作成者のメールアドレス', apply: '検索' },
    status: { draft: '下書き', published: '公開中', unpublished: '非公開', archived: 'アーカイブ済み' },
    validation: { valid: '合格', invalid: 'エラーあり' },
    listedInvalid: '新規プレイが失敗します',
    listedInvalidHint: 'この公開中の作品は内容チェックに合格しなくなったため、プレイヤーが新しくプレイを始めるとエラーになります。',
    table: { title: '作品', owner: '作成者', latestVersion: '最新バージョン', status: 'ステータス', validation: '内容チェック', featured: 'おすすめ', updatedAt: '更新日時' },
    notFeatured: 'おすすめ外',
    noVersion: 'バージョンなし',
    emptyTitle: '条件に一致する小説作品はありません。',
    actions: { preview: 'プレビュー', publish: '公開', unpublish: '非公開にする', featured: 'おすすめ順' },
    publishConfirm: '「{title}」を公開しますか？公開するとすぐに本棚に表示され、プレイヤーが新しくプレイを始められます。',
    blocked: { invalid: '内容チェック不合格のため公開できません', archived: 'アーカイブ済みのため公開できません' },
    unpublishConfirm: 'この作品を非公開にしますか？新しいプレイヤーの本棚には表示されなくなりますが、進行中のプレイはそのまま続けられます。',
    toast: {
      published: '「{title}」を公開しました。',
      unpublished: '「{title}」を非公開にしました。',
      featuredSet: '「{title}」のおすすめ順を保存しました。',
      featuredCleared: '「{title}」をおすすめから外しました。',
    },
    featuredForm: {
      title: 'おすすめ順',
      rank: 'おすすめ順',
      hint: '0 以上の整数を入力してください。数字が小さいほど本棚の前に表示されます。空にするとおすすめから外れます。',
      clear: 'おすすめを解除',
      save: '保存',
      invalid: '0 以上の整数を入力してください。',
    },
    detail: {
      title: '作品の詳細',
      owner: '作成者',
      language: '言語',
      status: 'ステータス',
      currentVersion: '現在のバージョン',
      validation: '内容チェック',
      listedAt: '最終公開日時',
      contentHash: '内容ハッシュ',
      createdAt: '作成日時',
      updatedAt: '更新日時',
      versions: 'バージョン',
      noVersions: 'この作品にはまだバージョンがありません。',
      assets: '素材',
      noAssets: 'アップロードされた素材はありません。',
      close: '閉じる',
      cover: '表紙',
      teaser: '本棚の紹介文',
      characters: '登場人物',
      playerRole: 'プレイヤー',
      opening: '冒頭の本文',
      empty: 'なし',
      openStudio: 'スタジオで開く',
      openStudioHint: 'スタジオでは作品の作成者本人だけが開けます。',
      openPlayer: 'プレイヤーサイトで見る',
      versionColumns: { version: 'バージョン', note: 'メモ', validation: '内容チェック', publishedAt: '公開日時', hash: 'パッケージハッシュ' },
      assetKinds: { cover: '表紙', location: '場所画像', state_image: '状態画像', item: 'アイテム画像' },
    },
    release: {
      title: '本番環境へ公開',
      hint: '作成者が Stage で切り出したバージョンを Main に送ります。Main はスラッグで作品を作成または更新し、そのバージョンを現在の内容にして公開します。画像はオブジェクトキー単位で差分コピーします。プレイ、プレイヤー、台帳はコピーしません。',
      refresh: '更新',
      stage: 'Stage',
      main: 'Main（本番）',
      selectedVersion: '選択中のバージョン',
      versionNote: 'バージョンのメモ',
      cutAt: '作成日時',
      connection: { connected: '接続正常', not_configured: '未設定', unreachable: '接続失敗' },
      connectionHelp: { not_configured: 'Stage に SCENARIO_RELEASE_TARGET_URL と SCENARIO_RELEASE_TOKEN を設定し（Main にも同じトークン）、API を再起動してください。', unreachable: 'Stage から Main に接続できません。接続先 URL、共有トークン、両環境の API ログを確認してください。' },
      mainVersion: 'Main の現在のバージョン',
      releasedAt: '最終公開',
      targetUrl: '接続先',
      notOnMain: 'Main にはまだありません',
      noVersions: '作成者がまだバージョンを切り出していません。バージョンはスタジオで作成します。',
      versionLabel: '公開するバージョン',
      noNote: 'メモなし',
      invalidVersion: 'このバージョンは現在の内容チェックに合格しないため、Main で拒否されます。',
      sameVersion: 'Main はすでにこのバージョンです。再公開すると内容と画像を同期し直します。',
      adminRequired: '公開できるのは管理者のみです。運営者は状態と記録を閲覧できます。',
      publish: '本番環境へ公開',
      confirmTitle: '本番環境へ公開しますか？',
      confirmBody: 'Main は「{title}」の {version} を現在の内容にしてすぐに公開します。Main に同じハッシュの画像があれば再利用します。',
      noUserData: 'プレイ、プレイヤー、台帳はコピーされません。',
      progress: '公開中です…完了するまでこのウィンドウを閉じないでください。',
      confirm: '公開する',
      successTitle: '本番環境に公開しました',
      successSummary: '{version} が Main で有効になりました · 新規アップロード {copied} 件、再利用 {reused} 件 · {size} をアップロード',
      historyTitle: '公開記録とログ',
      historyEmpty: '公開記録はまだありません。',
      operator: '操作者',
      startedAt: '開始日時',
      transfer: '画像（新規 / 再利用）',
      releaseId: '公開 ID',
      slugTaken: 'Main にはスラッグ「{slug}」の作品が Main の作成者によって作られています。公開チャネルでは上書きできないため、公開を無効にしています。',
      reasonCodes: {
        FORBIDDEN: 'Main が共有公開トークンを拒否しました。Stage と Main の SCENARIO_RELEASE_TOKEN を一致させてください。',
        NOT_FOUND: 'Main に小説公開のインターフェースまたは記録がありません。Main が同じバージョンのコードか確認してください。',
      },
      logs: {
        locked: 'Stage のバージョン {version} を確定しました（オブジェクト {assets} 件）',
        received: 'Stage のバージョン {version} を受信しました（オブジェクト {assets} 件）',
        sending: '本番環境へ公開パッケージを送信しています',
        syncing: '画像を検証して同期しています',
        writing: '画像の同期が完了しました（新規 {copied} 件、再利用 {reused} 件）。作品とバージョンを書き込んでいます',
        switched: '本番環境を {version} に切り替えました',
        failed: '失敗：{reason}',
      },
      stale: {
        hint: 'この公開は 30 分以上進んでいません。公開中に API が再起動した可能性があります。失敗として終了するまで、この作品の新しい公開をブロックします。',
        hintOperator: 'この公開は 30 分以上進んでおらず、この作品の新しい公開をブロックしています。管理者に終了を依頼してください。',
        finish: '失敗として終了',
      },
      status: { prepared: '準備済み', transferring: '転送中', applying: '書き込み中', succeeded: '成功', failed: '失敗' },
    },
    pager: { prev: '前へ', next: '次へ', pageSize: '表示件数', summary: '全 {total} 作品 · {page} / {pages} ページ' },
  },
  novelRuns: {
    title: '小説のプレイ記録',
    list: {
      filters: { email: 'プレイヤーのメール', emailPlaceholder: 'メールアドレスで検索', pack: '作品', packSearch: 'すべての作品（タイトル、スラッグ、作成者のメールで検索）', packSearching: '検索中…', packEmpty: '一致する作品はありません', packClear: '作品の絞り込みを解除', failedOnly: '失敗したジョブがあるプレイのみ', apply: '検索' },
      table: { player: 'プレイヤー', pack: '作品', status: 'ステータス', turns: 'ターン数', jobs: 'バックグラウンドジョブ', failedJobs: '失敗したジョブ', lastPlayed: '最終プレイ', actions: '操作' },
      statuses: { active: '進行中', archived: 'アーカイブ済み' },
      jobsPending: '待機中あり',
      jobsIdle: 'なし',
      unknownUser: '不明なプレイヤー',
      empty: '条件に一致するプレイはありません',
      audit: '監査',
      filterByPack: 'この作品のプレイだけを表示',
      pager: { prev: '前へ', next: '次へ', pageSize: '表示件数', summary: '全 {total} 件 · {page} / {pages} ページ' },
    },
    audit: {
      back: 'プレイ一覧',
      refresh: '更新',
      empty: 'なし',
      copy: 'コピー',
      copied: 'コピーしました',
      copyFailed: 'コピーに失敗しました：{message}',
      copyId: '{id} をコピー',
      points: '{points} pt',
      separator: '、',
      spoilerNotice: 'ネタバレを含む作者向けの表示です：隠し設定、キャラクターの知識、実際のプロンプト、モデル出力が表示されます。プレイヤーに共有しないでください。',
      tabs: { overview: '概要', characters: '登場人物', timeline: 'タイムライン', director: 'ディレクター', story: 'ストーリー', calls: '呼び出し', drama: 'デジタルヒューマン', raw: '生データ' },
      bar: {
        turns: 'ターン {count}',
        jobsPending: 'ジョブ待機中',
        jobsIdle: 'ジョブなし',
        writer: '執筆モデル {model}',
        writerTitle: 'このプレイの執筆者：{performer}；直近の実際のモデル：{model}',
        points: '合計 {points} pt',
        refreshTitle: '最終更新 {time}。読み取り専用で、このページを開いてもモデルは呼び出されません。',
        retryFailed: '失敗したジョブを再試行（{count}）',
      },
      overview: { runInfo: 'プレイ情報', player: 'プレイヤー', work: '作品', packageHash: '内容ハッシュ', created: '作成日時', lastPlayed: '最終プレイ', branch: 'ブランチ' },
      branch: { active: '現在', candidate: '候補', option: '{id} · {state} · {turns} ターン' },
      scene: {
        title: '現在のシーン',
        people: 'その場にいる人物',
        storyTime: '物語内の時間',
        items: 'ここにあるアイテム',
        recording: {
          pending: '本文は保存済みです。シーンとキャラクターの知識はバックグラウンドで更新中です。',
          failed: '本文は保存済みですが、バックグラウンドの記録に失敗しました。「呼び出し」タブのジョブ一覧から再試行してください。',
        },
      },
      request: {
        title: '直近のリクエスト',
        input: '入力',
        status: 'ステータス',
        elapsed: '所要時間',
        cost: 'コスト',
        stage: '段階',
        model: 'モデル',
        unrecorded: 'このリクエストにはモデル段階の記録が保存されていません。テンプレートからの復元は行いません。',
      },
      roles: { performer: '執筆者', structured: '構造化' },
      time: {
        day: '{day} 日目',
        phases: { morning: '朝', afternoon: '昼', evening: '夕方', night: '夜' },
      },
      requestStatuses: { generating: '生成中', committed: '確定', failed: '失敗', cancelled: 'キャンセル' },
      stageStatuses: { started: '開始', completed: '完了', failed: '失敗' },
      turns: {
        turn: 'ターン {seq}',
        modes: { mixed: 'セリフと行動', speech: 'セリフ', action: '行動', continue: '続ける' },
        recordingStates: { pending: '記録待ち', completed: '記録済み', failed: '記録失敗' },
      },
      characters: {
        list: '登場人物',
        openCount: '未完了 {count} 件',
        appearance: '外見',
        identity: '身分',
        initialGoal: '初期の目標',
        latestGoal: '最新の目標',
        sections: { opening: '開始時の設定', later: 'その後の記録', witness: '見聞と観察', memory: 'ローリング記憶' },
        facts: '知っている事実',
        relations: '関係',
        portrayal: '性格と口調',
        personality: '性格',
        speechStyle: '口調',
        cues: '演技の手がかり',
        examples: '口調の例（履歴ではありません）',
        attitude: '態度',
        goals: '目標',
        threads: '未完了の事項',
        thread: '事項',
        witnessed: '見聞した段落',
        witnessTurn: 'ターン',
        witnessText: '段落',
        witnessBy: '見聞した人物',
        witnessPending: '見聞は物語の記録待ちです：ターン {turns}',
        witnessFailed: '{range} の物語記録に失敗しました：{reason}',
        observations: '観察',
        memoryProgress: 'ターン {count} まで',
      },
      timeline: {
        positions: '位置の分布',
        placePeople: '：{people}',
        events: 'イベント',
        audience: '見聞した人物',
        moves: '移動',
        timeChange: '物語内の時間',
        transfers: 'アイテムの移動',
        kinds: { move: '移動', time: '物語内の時間', transfer: 'アイテムの移動', witness: '見聞' },
        items: 'アイテム',
        item: 'アイテム',
        holder: '所持者',
        place: '場所',
        unheld: '所持者なし',
      },
      director: {
        on: 'ディレクター オン',
        off: 'ディレクター オフ',
        unknown: 'ディレクターの記録なし',
        revision: 'リビジョン {revision}',
        latest: '最新の提案',
        directionStatus: 'ステータス',
        basis: '根拠',
        validThrough: '有効期限',
        guidanceId: '提案',
        deliveries: 'ターンごとの受け渡し',
        deliveriesHint: '「執筆者に渡した」は保存された注入記録だけで判断します。本文からはモデルが提案を採用したかどうかは証明できません。',
        turn: 'ターン',
        delivery: '受け渡し状態',
        passedWriter: '執筆者に渡した',
        reason: '理由',
        yes: 'はい',
        no: 'いいえ',
        notRecorded: '記録なし',
        hashPending: '計算中',
        hashFailed: '計算できません',
        hashFailedHint: 'このブラウザでは好みのハッシュを計算できないため（HTTPS または localhost が必要です）、提案が使えるかどうか判断できません。',
        statuses: {
          disabled: 'オフ',
          pending: '準備中',
          ready: '利用可能',
          unavailable: '提案なし',
          available: '利用可能',
          expired: '期限切れ',
          not_ready: '未準備',
          injected_direction: '注入済み',
        },
        statusHints: {
          disabled: 'オフ：呼び出しも注入も行いません。',
          pending: 'バックグラウンドで提案を準備中です。本文の生成は待ちません。',
          ready: '方向性を利用できます。',
          unavailable: '利用できる提案はありません。',
          available: '現在の段階で利用できます。',
          expired: '参考として表示しているだけで、もう注入されません。',
          not_ready: '未注入：提案がまだ準備できていませんでした。',
          injected_direction: '段階の方向性を注入しました。',
        },
        reasons: {
          director_disabled: 'オフ：呼び出しも注入も行いません。',
          guidance_pending: 'バックグラウンドで提案を準備中です。本文の生成は待ちません。',
          guidance_unavailable: '利用できる提案はありません。',
          guidance_expired: '参考として表示しているだけで、もう注入されません。',
          recording_pending: '本文の記録はまだバックグラウンドで準備中です。',
          director_revision_changed: 'ディレクター設定のリビジョンが変わりました。',
          preferences_changed: '物語外の好みが変わりました。',
          phase_direction: '段階の方向性を含めました。',
        },
      },
      preferences: {
        title: '物語外の好み',
        kinds: { pace: 'テンポ', focus: '注目する人物', direction: '方向性', expectation: '物語外の期待' },
        scopes: { branch: 'このプレイ全体', next_4_turns: '次の 4 ターン' },
        sources: { explicit_ui: 'プレイヤーが設定', explicit_ooc_expectation: 'プレイヤーが記述' },
        paces: { linger: 'じっくり', follow: 'プレイヤーに合わせる', advance: '先へ進める' },
      },
      story: {
        title: 'ストーリー記録',
        turnCount: '{count} ターン',
        opening: '冒頭',
        narrator: 'ナレーター',
        playerInput: 'プレイヤーの入力',
        channels: { narration: 'ナレーション', dialogue: 'セリフ', action: '行動' },
        metadataPending: '記録待ち',
        audience: '見聞した人物：{names}',
        generating: 'ターンを生成中です。生成途中の下書きはプレイ処理の中にしかなく、ここには表示されません。',
      },
      sources: {
        evidence: '根拠 {count}',
        evidenceLabel: '根拠の出典',
        missing: '出典の本文は保存されていません',
        range: 'ターン {from}–{through}',
        turn: 'ターン {count}',
        kinds: { opening: '冒頭', author_fact: '作者が設定した開始時の事実', event: '記録済みのイベント', turn: 'ストーリーのターン', unknown: '保存済みの根拠' },
      },
      memoryKinds: {
        observed: '観察',
        reported: '伝聞',
        belief: '信念',
        interpretation: '解釈',
        correction: '記憶の訂正',
        conflict: '記憶の矛盾',
        record: '記憶の記録',
      },
      calls: {
        title: 'モデル呼び出し',
        count: '呼び出し {count} 回',
        totalCost: '総コスト {cost}',
        failedCount: '失敗 {count} 回',
        time: '時刻',
        source: '呼び出し元',
        role: '役割',
        model: 'モデル · プロバイダー',
        status: 'ステータス',
        ttft: '最初のトークン',
        duration: '所要時間',
        tokens: 'トークン 入力 / 出力',
        cost: 'コスト',
        expand: 'リクエスト本文と出力を表示',
        sourceRequest: 'リクエスト',
        sourceJob: 'バックグラウンドジョブ',
        sourceOther: 'その他',
        statuses: { ok: '成功', error: 'エラー', aborted: '中断' },
        callId: '呼び出し',
        authNotRecorded: '認証ヘッダーと環境変数は記録されません',
        requestBody: 'リクエスト本文',
        messageCount: '{count} 件のメッセージ',
        chars: '{count} 文字',
        output: '出力',
        reasoning: '推論',
        finishReason: '終了理由',
        protocol: 'プロトコル',
        unavailable: 'プラットフォームの監査にはありません',
      },
      drama: {
        title: 'デジタルヒューマンの演出',
        hint: '1 ターンに 1 回。開始時にポイントを仮押さえし、最初のフレームより前に失敗すると自動で返却されます。',
        time: '開始',
        person: '人物と状態',
        duration: '時間',
        firstFrame: '最初のフレームまで',
        result: '結果',
        points: 'ポイント',
        refund: '返却',
        refunded: '返却済み',
        refundedTotal: '{points} ポイント返却',
        count: '{count} 回',
        empty: 'このプレイにはデジタルヒューマンの演出がありません。',
        statuses: { starting: '接続中', live: '演出中', ended: '終了' },
        reasons: { completed: '完了', cancelled_during_start: '開始中に取り消し', disconnected: '切断', start_failed: '開始に失敗', playback_failed: '再生に失敗', hidden: 'ページ非表示', switched_off: 'オフに切り替え', unmounted: 'ページを離脱', turn_cancelled: 'ターン取り消し', replaced: '新しい演出に置き換え', browser_disconnected: '制御接続が切断', expired: '時間上限に到達', interrupted: 'サーバー再起動で中断' },
      },
      jobs: {
        title: 'バックグラウンドジョブ',
        kind: '種類',
        range: 'ターン',
        status: 'ステータス',
        attempts: '試行回数',
        nextRetry: '次回の再試行',
        error: 'エラー',
        retry: '再試行',
        retried: '{count} 件のジョブを再試行キューに入れました',
        trigger: 'きっかけ：{trigger}',
        completed: '完了：{time}',
        kinds: { narrative_record: 'ターンの記録', memory: '記憶', director: 'ディレクター', suggestions: '返答の候補' },
        triggers: { cadence: '4 ターンごとの定期実行', enabled: 'ディレクターをオンにした', preference_changed: '好みが変わった', forked: 'ブランチを分岐した' },
        statuses: { pending: '待機中', completed: '完了', failed: '失敗', superseded: '無効化' },
      },
      requests: { title: 'ターンのリクエスト', time: '開始', turn: 'ターン', input: '入力', status: 'ステータス', error: 'エラー', elapsed: '所要時間', points: 'ポイント', id: 'ID', diagnostics: '検証フィードバック', diagnosticsCount: '{count} 件', diagnosticsExpand: '検証フィードバック {count} 件を表示' },
      diagnostics: {
        raw: 'モデルの原文 · {count} 文字',
        kinds: {
          narrative_format: '形式チェック',
          narrative_preamble: '本文前の余分な文章',
          narrative_tag_normalization: 'タグの正規化',
          narrative_recording: 'ストーリーの記録',
          narrative_continuity: '一貫性レビュー',
          memory_owner_failure: '記憶の整理に失敗',
        },
      },
      errors: {
        unknown: '未分類のエラー',
        internal_error: 'サーバー内部エラー',
        interrupted: 'サービスの再起動で中断されました',
        cancelled: 'キャンセルされました',
        insufficient_balance: 'ポイント残高が不足しています',
        stale_turn: 'このターンの完了前にセーブが変わりました',
        busy: '別のリクエストを処理中でした',
        run_archived: 'プレイはアーカイブ済みです',
        invalid_data: 'データが不正です',
        content_filter: 'コンテンツフィルターでブロックされました',
        model_output_limit: 'モデル出力が長さの上限に達しました',
        model_response_blocked: 'モデルが応答を拒否したか、安全ポリシーでブロックされました',
        incomplete_model_output: 'モデル出力が不完全でした',
        model_not_configured: 'この段階にモデルが設定されていません',
        context_limit: 'コンテキストがモデルの上限を超えています',
        invalid_structured_json: '構造化出力を解析できませんでした',
        invalid_narrative_format: '本文の出力形式が不正です',
        invalid_performance: '人物またはシーンの設定が無効です',
        invalid_performance_states: '執筆者の状態出力が不正です',
        missing_narrative_tags: '本文に話者タグがありません',
        invalid_speaker: '話者が不正です',
        invalid_narrative_record: '物語記録の出力が不正です',
        narrative_recording_failed: '物語の記録に失敗しました',
        narrative_record_gap: '前のターンがまだ記録されていません',
        invalid_story_time: '物語内の時間が不正です',
        invalid_item_transfer: 'アイテムの移動が不正です',
        invalid_scene_location: 'シーンの場所が不正です',
        invalid_scene_path: '移動経路が不正です',
        source_conflict: '根拠の出典が矛盾しています',
        memory_too_long: '記憶の要約が長すぎます',
        memory_source_too_large: '1 回の記憶ジョブには素材が多すぎます',
        memory_context_limit: '記憶のコンテキストがモデルの上限を超えています',
        memory_backlog_waiting: '前の記憶ジョブを待っています',
        invalid_correction: '記憶の訂正が不正です',
        unsupported_correction: 'サポートされていない記憶の訂正です',
        invalid_player_suggestions: '返答候補の出力が不正です',
        invalid_preference: '好みの設定が不正です',
        job_conflict: 'ジョブが競合しています',
        package_integrity_failed: '作品内容の整合性チェックに失敗しました',
      },
      raw: {
        title: '生データ',
        pack: '作品の内容',
        snapshot: '完全なスナップショット',
        requests: 'リクエスト記録',
        contextNote: 'context_records は実行時のコンテキストのスナップショットです。モデルに実際に送られた内容は「呼び出し」タブのリクエスト本文だけです。',
      },
    },
  },
  novelErrors: {
    unknown: '未分類のエラー',
    codes: {
      BAD_REQUEST: 'サーバーがリクエストを不正として拒否しました。',
      VALIDATION_ERROR: 'サーバーがリクエストを不正として拒否しました。',
      UNAUTHORIZED: 'ログインの有効期限が切れました。もう一度ログインしてください。',
      FORBIDDEN: 'このアカウントにはこの操作の権限がありません。',
      NOT_FOUND: '対象はもう存在しません。',
      CONFLICT: 'データが変更されました。更新してからもう一度お試しください。',
      NOVEL_RELEASE_NOT_CONFIGURED: 'Stage に本番環境の公開先が設定されていません。',
      NOVEL_RELEASE_TARGET_UNREACHABLE: 'Stage から本番環境に接続できません。詳しくは下の公開記録を確認してください。',
      NOVEL_RELEASE_TARGET_REJECTED: '本番環境が公開を拒否しました。理由は下の公開記録を確認してください。',
      NOVEL_RELEASE_FAILED: '本番環境で公開を適用できませんでした。原因は記録の詳細にあります。',
      NOVEL_RELEASE_STORAGE_RESIDUE: '内容に書き換えられないストレージのアドレス（旧 OSS ドメイン、http、クエリ付き）が残っています。スタジオで画像のアドレスを直し、新しいバージョンを切り出してから公開してください。',
      NOVEL_RELEASE_STALE: 'この公開は停止していた（公開中に API が再起動した）ため、管理者が失敗として終了しました。',
      NOVEL_RELEASE_IN_PROGRESS: '本番環境はまだこの公開を処理しています。記録は処理中のままで、受領確認が確定すると更新されます。後で更新してください。',
      NOVEL_RELEASE_ALREADY_FAILED: 'この公開 ID はすでに失敗しています。新しく公開してください。',
      NOVEL_RELEASE_CHECKSUM_MISMATCH: '本番環境で公開パッケージのチェックサムが一致しませんでした。',
      NOVEL_RELEASE_BUNDLE_INVALID: '本番環境で公開パッケージのオブジェクト一覧が内容と一致しませんでした。',
      RATE_LIMITED: 'リクエストが多すぎます。しばらくしてからもう一度お試しください。',
      INTERNAL_ERROR: 'サーバーエラーです。しばらくしてからもう一度お試しください。',
      HTTP_ERROR: 'リクエストに失敗しました。',
    },
    reasons: {
      release_in_progress: 'この作品は公開処理中です。終わるまでお待ちください。',
      release_id_conflict: 'この公開 ID はすでに別の内容に使われています。',
      release_slug_taken: 'Main には同じスラッグで Main の作成者が作った作品があるため、公開で上書きできません。',
      release_version_conflict: 'Main には同じバージョン番号で内容の異なるバージョンがあります。スタジオで新しいバージョンを切り出して公開してください。',
      release_content_invalid: 'このバージョンは Main の現在のルールで内容チェックに合格しないため、Main は適用しませんでした。',
      release_pack_archived: 'Main のこの作品はアーカイブ済みのため、公開できません。',
      release_not_stale: 'この公開はまだ進んでいます。終了できるのは 30 分以上止まっている公開だけです。',
      release_invalid_transition: 'この公開記録はすでに終了しています。更新して状態を確認してください。',
      release_not_found: 'この公開記録はもう存在しません。',
      pack_not_found: 'この作品はもう存在しません。',
      pack_content_invalid: '内容がチェックに合格しないため、作品を公開できません。',
      invalid_status_transition: '作品の現在のステータスではこの操作はできません。更新してからもう一度お試しください。',
      invalid_featured_rank: 'おすすめ順は 0 以上の整数にしてください。',
      run_not_found: 'このプレイはもう存在しません。',
      run_archived: 'このプレイはアーカイブ済みのため、ジョブを再試行できません。',
      adopt_forbidden: '採用できるのは元のプレイの持ち主本人だけです。',
      stale_comparison: '比較の開始後に元のプレイが進みました。比較をやり直してください。',
      already_adopted: 'この比較はすでに片側を採用済みです。',
      nothing_to_adopt: 'この側にはまだ採用できる新しいターンがありません。',
      comparison_not_found: 'この比較はもう存在しません（比較は 24 時間後に自動削除されます）。',
      invalid_comparison_source: '比較用のプレイは比較の元にできません。',
      model_not_configured: '選んだ執筆モデルは設定されていません。',
      invalid_performer: '選んだモデルは執筆チェーンにありません。',
      invalid_director_comparison: '監督のオン/オフだけを比べるときは、両側を同じモデルにしてください。',
      narrative_required: 'この作品には本文がないため、比較できません。',
      busy: 'このプレイは生成中です。終わってから再度お試しください。',
    },
  },
}
